// Advice is authored per existing industry destination; never create pages from this registry.
export type IndustryAdvice = { name: string; focus: string; proof: string; intake: string };
export const INDUSTRY_ADVICE: Record<string, IndustryAdvice> = {
  "/hvac-marketing-colorado": {
    "name": "HVAC",
    "focus": "repair versus replacement and seasonal maintenance",
    "proof": "equipment types and technician credentials",
    "intake": "system type and urgency"
  },
  "/plumbing-marketing-colorado": {
    "name": "Plumbing",
    "focus": "water heaters, drains and sewer work",
    "proof": "licensed team and photos of completed repairs",
    "intake": "problem, property type and urgency"
  },
  "/electrical-contractor-marketing-colorado": {
    "name": "Electrical",
    "focus": "panel upgrades, EV chargers and troubleshooting",
    "proof": "licenses and examples of inspected installations",
    "intake": "electrical issue and existing panel"
  },
  "/roofing-marketing-colorado": {
    "name": "Roofing",
    "focus": "repairs, replacement and storm inspections",
    "proof": "roof materials and documented completed projects",
    "intake": "roof type and inspection needs"
  },
  "/concrete-marketing-colorado": {
    "name": "Concrete & Excavation",
    "focus": "driveways, grading and site preparation",
    "proof": "finished surfaces and access requirements",
    "intake": "project dimensions and site access"
  },
  "/cleaning-marketing-colorado": {
    "name": "Cleaning Services",
    "focus": "recurring cleans versus one-time deep cleaning",
    "proof": "cleaning checklist and actual team photos",
    "intake": "property size and preferred frequency"
  },
  "/snow-removal-marketing-colorado": {
    "name": "Snow Removal",
    "focus": "residential routes versus commercial snow contracts",
    "proof": "equipment and clearly stated service triggers",
    "intake": "property access and contract needs"
  },
  "/pest-control-marketing-colorado": {
    "name": "Pest Control",
    "focus": "inspection, treatment and prevention",
    "proof": "methods, qualifications and follow-up process",
    "intake": "pest type and affected areas"
  },
  "/painting-marketing-colorado": {
    "name": "Painting",
    "focus": "interior, exterior and cabinet refinishing",
    "proof": "surface preparation and real finish photos",
    "intake": "rooms or exterior surfaces and timing"
  },
  "/fireplace-chimney-marketing-colorado": {
    "name": "Fireplace & Chimney",
    "focus": "inspection, sweeping and fireplace repairs",
    "proof": "qualifications and photos of inspected systems",
    "intake": "fireplace type and last service date"
  },
  "/garage-door-marketing-colorado": {
    "name": "Garage Doors",
    "focus": "spring repair, opener problems and replacement",
    "proof": "door types and warranty terms",
    "intake": "door symptoms and repair urgency"
  },
  "/tree-service-marketing-colorado": {
    "name": "Tree Service",
    "focus": "pruning, removal and stump grinding",
    "proof": "insurance details and safe-work practices",
    "intake": "tree size, access and nearby structures"
  },
  "/landscaping-marketing-colorado": {
    "name": "Landscaping",
    "focus": "xeriscaping, planting and ongoing maintenance",
    "proof": "real gardens and seasonal care examples",
    "intake": "yard size and project priorities"
  },
  "/general-contractor-marketing-colorado": {
    "name": "General Contractors",
    "focus": "renovation scope and project management",
    "proof": "licenses, project photos and clear change-order terms",
    "intake": "project scope and desired start date"
  },
  "/junk-removal-marketing-colorado": {
    "name": "Junk Removal",
    "focus": "single-item pickups versus full cleanouts",
    "proof": "disposal practices and volume-based quote explanation",
    "intake": "item list, access and pickup timing"
  },
  "/moving-company-marketing-colorado": {
    "name": "Moving Companies",
    "focus": "local moves, packing and specialty items",
    "proof": "coverage, handling process and verified business details",
    "intake": "move date, addresses and access constraints"
  },
  "/restoration-marketing-colorado": {
    "name": "Water Damage Restoration",
    "focus": "emergency response, drying and reconstruction",
    "proof": "credentials and documented drying process",
    "intake": "damage source, affected area and urgency"
  },
  "/accountant-marketing-colorado": {
    "name": "Accountants & CPAs",
    "focus": "bookkeeping, tax preparation and advisory work",
    "proof": "professional qualifications and service boundaries",
    "intake": "business type and accounting needs"
  },
  "/insurance-agency-marketing-colorado": {
    "name": "Insurance Agencies",
    "focus": "coverage comparisons and renewal questions",
    "proof": "licenses and clear carrier relationships",
    "intake": "coverage type and renewal timing"
  },
  "/real-estate-broker-property-manager-marketing-colorado": {
    "name": "Real Estate",
    "focus": "buying, selling and property management",
    "proof": "agent credentials and real neighborhood experience",
    "intake": "property goals and preferred area"
  },
  "/tutor-marketing-colorado": {
    "name": "Tutors & Coaches",
    "focus": "subjects, age groups and coaching goals",
    "proof": "qualifications and teaching approach",
    "intake": "learner goals and availability"
  },
  "/photographer-marketing-colorado": {
    "name": "Photographers",
    "focus": "session types, deliverables and usage rights",
    "proof": "real galleries and clear image licensing",
    "intake": "event date and intended image use"
  },
  "/chiropractic-marketing-colorado": {
    "name": "Chiropractic",
    "focus": "first visits and treatment approach",
    "proof": "provider credentials and patient-friendly explanations",
    "intake": "appointment preference without sensitive medical details"
  },
  "/gym-marketing-colorado": {
    "name": "Gyms & Fitness Studios",
    "focus": "memberships, classes and trial visits",
    "proof": "actual schedules and real facility photos",
    "intake": "class interests and preferred visit time"
  },
  "/salon-spa-marketing-colorado": {
    "name": "Salons & Spas",
    "focus": "treatments, durations and booking policies",
    "proof": "staff qualifications and real work examples",
    "intake": "desired service and appointment time"
  },
  "/boutique-retail-marketing-colorado": {
    "name": "Boutiques & Retail",
    "focus": "product selection and local pickup",
    "proof": "current stock and accurate store hours",
    "intake": "product question or pickup preference"
  },
  "/restaurant-marketing-colorado": {
    "name": "Restaurants & Cafés",
    "focus": "menus, reservations and dietary options",
    "proof": "current menu and real dining photos",
    "intake": "party size and reservation date"
  },
  "/auto-repair-marketing-colorado": {
    "name": "Auto Repair & Detailing",
    "focus": "diagnostics, routine maintenance and detailing packages",
    "proof": "technician credentials and estimate policies",
    "intake": "vehicle make, model and symptoms"
  },
  "/auto-dealer-marketing-colorado": {
    "name": "Independent Auto Dealers",
    "focus": "inventory, financing steps and vehicle history",
    "proof": "real vehicle photos and transparent terms",
    "intake": "vehicle interest and viewing availability"
  },
  "/dog-trainer-marketing-colorado": {
    "name": "Dog Trainers & K9 Schools",
    "focus": "puppy classes, behavior goals and training formats",
    "proof": "trainer qualifications and methods",
    "intake": "dog age, goals and class availability"
  },
  "/law-firm-marketing-colorado": {
    "name": "Law Firms",
    "focus": "practice areas and consultation process",
    "proof": "attorney credentials and honest scope of representation",
    "intake": "practice area and callback details without confidential facts"
  },
  "/medical-dental-marketing-colorado": {
    "name": "Medical & Dental",
    "focus": "new patient visits, services and insurance questions",
    "proof": "provider credentials and accurate office details",
    "intake": "appointment preference without sensitive health information"
  },
  "/personal-injury-attorney-marketing-colorado": {
    "name": "Personal Injury Attorneys",
    "focus": "claim evaluation and consultation steps",
    "proof": "attorney credentials and clear fee explanation",
    "intake": "callback details without confidential case documents"
  },
  "/criminal-defense-attorney-marketing-colorado": {
    "name": "Criminal Defense Attorneys",
    "focus": "charges handled and consultation process",
    "proof": "attorney qualifications and clear confidentiality guidance",
    "intake": "safe callback details and consultation urgency"
  },
  "/family-law-attorney-marketing-colorado": {
    "name": "Family Law Attorneys",
    "focus": "divorce, custody and mediation options",
    "proof": "attorney credentials and process explanations",
    "intake": "consultation preferences without private family details"
  },
  "/estate-planning-attorney-marketing-colorado": {
    "name": "Estate Planning Attorneys",
    "focus": "wills, trusts and estate administration",
    "proof": "attorney credentials and document process",
    "intake": "planning goal and consultation preference"
  },
  "/dentist-marketing-colorado": {
    "name": "Dentists",
    "focus": "preventive care, emergencies and treatment options",
    "proof": "provider credentials and real office photos",
    "intake": "appointment preference and callback details"
  },
  "/orthodontist-marketing-colorado": {
    "name": "Orthodontists",
    "focus": "braces, aligners and consultation expectations",
    "proof": "provider qualifications and treatment explanations",
    "intake": "consultation preference without sensitive records"
  },
  "/physical-therapy-marketing-colorado": {
    "name": "Physical Therapy Clinics",
    "focus": "conditions served and first appointment expectations",
    "proof": "therapist credentials and care approach",
    "intake": "appointment preference and referral questions"
  },
  "/med-spa-marketing-colorado": {
    "name": "Med Spas",
    "focus": "treatment options, recovery questions and consultations",
    "proof": "provider credentials and consented results",
    "intake": "consultation interest without sensitive health information"
  },
  "/plastic-surgeon-marketing-colorado": {
    "name": "Plastic Surgeons",
    "focus": "consultation steps, procedure suitability and recovery",
    "proof": "board credentials accurately described and consented images",
    "intake": "consultation request without medical records"
  },
  "/dermatologist-marketing-colorado": {
    "name": "Dermatologists",
    "focus": "medical versus cosmetic care and appointment options",
    "proof": "provider credentials and service explanations",
    "intake": "visit preference without diagnostic details"
  },
  "/ophthalmologist-marketing-colorado": {
    "name": "Ophthalmologists",
    "focus": "eye care services and consultation expectations",
    "proof": "provider credentials and accurate referral information",
    "intake": "appointment preference without clinical records"
  },
  "/commercial-roofing-marketing-colorado": {
    "name": "Commercial Roofing",
    "focus": "roof systems, inspection and maintenance contracts",
    "proof": "completed commercial projects and safety practices",
    "intake": "building type, roof area and access requirements"
  },
  "/steel-building-marketing-colorado": {
    "name": "Steel Building Companies",
    "focus": "design scope, site work and erection services",
    "proof": "real buildings and specification examples",
    "intake": "dimensions, intended use and site location"
  },
  "/custom-home-builder-remodeler-marketing-colorado": {
    "name": "Custom Home Builders",
    "focus": "design stages, budgets and construction scope",
    "proof": "real project portfolios and clearly described process",
    "intake": "build location, project stage and budget range"
  },
  "/trucking-marketing-colorado": {
    "name": "Trucking & Hauling Companies",
    "focus": "load types, routes and hauling requirements",
    "proof": "equipment, qualifications and insurance details",
    "intake": "load dimensions and pickup destination"
  },
  "/equipment-rental-marketing-colorado": {
    "name": "Equipment Rental Companies",
    "focus": "equipment availability, delivery and rental terms",
    "proof": "actual equipment specifications and condition photos",
    "intake": "equipment type, dates and delivery location"
  },
  "/manufacturing-marketing-colorado": {
    "name": "Manufacturing Companies",
    "focus": "capabilities, lead times and quality requirements",
    "proof": "certifications accurately described and real production examples",
    "intake": "specifications and quantity without proprietary attachments"
  },
  "/franchise-marketing-colorado": {
    "name": "Franchise Businesses",
    "focus": "local services and location-specific offers",
    "proof": "accurate local operator and brand details",
    "intake": "nearest location and service interest"
  },
  "/mortgage-broker-marketing-colorado": {
    "name": "Mortgage Brokers",
    "focus": "loan options, qualification steps and closing questions",
    "proof": "licensing and transparent fee explanations",
    "intake": "callback preference without financial account details"
  },
  "/commercial-contractor-marketing-colorado": {
    "name": "Commercial Contractors",
    "focus": "commercial buildouts, scheduling and project scope",
    "proof": "completed projects and licensing details",
    "intake": "site type, scope and procurement timing"
  },
  "/medical-marketing-colorado": {
    "name": "Medical Practices",
    "focus": "services, new patient access and appointment requests",
    "proof": "provider credentials and current office information",
    "intake": "appointment preference without health records"
  },
  "/appliance-repair-web-design-colorado": {
    "name": "Appliance Repair",
    "focus": "repairable appliance types, brands and diagnostic visits",
    "proof": "technician qualifications and diagnostic fee explanation",
    "intake": "brand, model and fault symptoms"
  },
  "/basement-finishing-web-design-colorado": {
    "name": "Basement Finishing",
    "focus": "layout, moisture checks and permitting questions",
    "proof": "real before-and-after layouts and scope explanation",
    "intake": "basement size and intended use"
  },
  "/bathroom-remodeling-web-design-colorado": {
    "name": "Bathroom Remodeling",
    "focus": "layout changes, fixtures and accessibility options",
    "proof": "real remodel photos and waterproofing process",
    "intake": "room dimensions and desired changes"
  },
  "/carpet-cleaning-web-design-colorado": {
    "name": "Carpet Cleaning",
    "focus": "stain treatment, cleaning methods and drying time",
    "proof": "method explanations and real cleaning photos",
    "intake": "room count, carpet type and stains"
  },
  "/deck-builder-web-design-colorado": {
    "name": "Deck Builders",
    "focus": "deck materials, railings and replacement options",
    "proof": "completed decks and permitting process",
    "intake": "deck dimensions and material preference"
  },
  "/demolition-web-design-colorado": {
    "name": "Demolition",
    "focus": "interior versus structural demolition and disposal",
    "proof": "licensing, safety practices and actual equipment",
    "intake": "structure type and site access"
  },
  "/drywall-web-design-colorado": {
    "name": "Drywall Contractors",
    "focus": "repairs, installation and texture matching",
    "proof": "close-up finish photos and preparation process",
    "intake": "affected area and texture requirements"
  },
  "/dumpster-rental-web-design-colorado": {
    "name": "Dumpster Rental",
    "focus": "container sizes, allowed materials and pickup terms",
    "proof": "real container dimensions and transparent restrictions",
    "intake": "material type, dates and delivery access"
  },
  "/epoxy-flooring-web-design-colorado": {
    "name": "Epoxy Flooring",
    "focus": "surface preparation, coating systems and curing time",
    "proof": "real finished floors and preparation examples",
    "intake": "floor area and current surface condition"
  },
  "/excavation-web-design-colorado": {
    "name": "Excavation",
    "focus": "grading, trenching and site preparation",
    "proof": "equipment and documented site-work examples",
    "intake": "site location, access and work dimensions"
  },
  "/fencing-web-design-colorado": {
    "name": "Fencing Contractors",
    "focus": "fence materials, repairs and property-line questions",
    "proof": "real installations and gate examples",
    "intake": "fence length, material and gate needs"
  },
  "/flooring-web-design-colorado": {
    "name": "Flooring Installers",
    "focus": "material selection, subfloor checks and installation",
    "proof": "completed floors and preparation details",
    "intake": "room dimensions and current flooring"
  },
  "/foundation-repair-web-design-colorado": {
    "name": "Foundation Repair",
    "focus": "inspection, repair options and monitoring",
    "proof": "qualifications and documented assessment process",
    "intake": "observed symptoms and inspection preference"
  },
  "/garage-builder-web-design-colorado": {
    "name": "Garage Builders",
    "focus": "garage size, site planning and utility options",
    "proof": "completed structures and permitting process",
    "intake": "dimensions, use and proposed site"
  },
  "/gutter-web-design-colorado": {
    "name": "Gutter Companies",
    "focus": "repairs, replacement and drainage solutions",
    "proof": "real gutter installations and material specifications",
    "intake": "roofline details and drainage problem"
  },
  "/handyman-web-design-colorado": {
    "name": "Handyman Services",
    "focus": "small repairs, service limits and bundled visits",
    "proof": "real repair examples and clear scope boundaries",
    "intake": "task list and property access"
  },
  "/insulation-web-design-colorado": {
    "name": "Insulation Contractors",
    "focus": "insulation types, air sealing and assessment",
    "proof": "installation photos and clearly explained materials",
    "intake": "home area and comfort concerns"
  },
  "/irrigation-web-design-colorado": {
    "name": "Irrigation Companies",
    "focus": "sprinkler repairs, installation and winterization",
    "proof": "real systems and seasonal service checklist",
    "intake": "zone count and system problem"
  },
  "/kitchen-remodeling-web-design-colorado": {
    "name": "Kitchen Remodeling",
    "focus": "layout, cabinetry and renovation stages",
    "proof": "real kitchens and clear project sequencing",
    "intake": "room size and renovation priorities"
  },
  "/locksmith-web-design-colorado": {
    "name": "Locksmiths",
    "focus": "lockouts, rekeying and security hardware",
    "proof": "verified business identity and upfront callout terms",
    "intake": "location and lock issue without security codes"
  },
  "/masonry-web-design-colorado": {
    "name": "Masonry Contractors",
    "focus": "brickwork, stonework and mortar repairs",
    "proof": "close-up project photos and material examples",
    "intake": "project type and affected dimensions"
  },
  "/mold-remediation-web-design-colorado": {
    "name": "Mold Remediation",
    "focus": "assessment, containment and remediation scope",
    "proof": "qualifications and documented containment practices",
    "intake": "affected area and inspection needs"
  },
  "/paving-web-design-colorado": {
    "name": "Paving Contractors",
    "focus": "asphalt, concrete and maintenance options",
    "proof": "completed surfaces and preparation details",
    "intake": "surface area, access and existing condition"
  },
  "/pole-barn-builder-web-design-colorado": {
    "name": "Pole Barn Builders",
    "focus": "building uses, dimensions and site preparation",
    "proof": "real structures and specification examples",
    "intake": "planned use, size and site location"
  },
  "/pool-service-web-design-colorado": {
    "name": "Pool Service",
    "focus": "maintenance, equipment repair and seasonal opening",
    "proof": "service checklist and real equipment examples",
    "intake": "pool type and service frequency"
  },
  "/pressure-washing-web-design-colorado": {
    "name": "Pressure Washing",
    "focus": "surface-safe washing and property preparation",
    "proof": "real results with surface types identified",
    "intake": "surface type, area and access"
  },
  "/remodeling-web-design-colorado": {
    "name": "Remodeling Contractors",
    "focus": "renovation scope, sequencing and change orders",
    "proof": "real project galleries and clear estimating process",
    "intake": "rooms involved and desired changes"
  },
  "/septic-web-design-colorado": {
    "name": "Septic Services",
    "focus": "pumping, inspection and repair options",
    "proof": "qualifications and clearly stated service limits",
    "intake": "system location and service concern"
  },
  "/siding-web-design-colorado": {
    "name": "Siding Contractors",
    "focus": "materials, replacement and weather protection",
    "proof": "actual installations and material specifications",
    "intake": "exterior area and material preference"
  },
  "/solar-web-design-colorado": {
    "name": "Solar Installers",
    "focus": "system suitability, financing and installation steps",
    "proof": "credentials and honest assumptions in savings estimates",
    "intake": "property type and consultation preference"
  },
  "/well-drilling-web-design-colorado": {
    "name": "Well Drilling",
    "focus": "site evaluation, drilling scope and pump options",
    "proof": "qualifications and equipment details",
    "intake": "site location and intended water use"
  },
  "/window-cleaning-web-design-colorado": {
    "name": "Window Cleaning",
    "focus": "interior, exterior and hard-water cleaning",
    "proof": "real cleaning examples and access explanation",
    "intake": "window count and building height"
  },
  "/acupuncture-web-design-colorado": {
    "name": "Acupuncture",
    "focus": "first visits, session structure and suitability",
    "proof": "provider credentials and clear scope of practice",
    "intake": "appointment preference without medical history"
  },
  "/addiction-treatment-web-design-colorado": {
    "name": "Addiction Treatment",
    "focus": "admission steps, care setting and support options",
    "proof": "licensing and accurately described programs",
    "intake": "safe callback details without treatment records"
  },
  "/allergist-web-design-colorado": {
    "name": "Allergists",
    "focus": "testing options and first visit expectations",
    "proof": "provider credentials and accurate referral details",
    "intake": "appointment preference without sensitive records"
  },
  "/audiology-web-design-colorado": {
    "name": "Audiology",
    "focus": "hearing tests, device options and follow-up",
    "proof": "provider qualifications and transparent service process",
    "intake": "consultation preference without health details"
  },
  "/cardiology-web-design-colorado": {
    "name": "Cardiology",
    "focus": "consultation access, referrals and offered services",
    "proof": "provider credentials and accurate care setting",
    "intake": "callback preference without symptoms or medical records"
  },
  "/endodontist-web-design-colorado": {
    "name": "Endodontists",
    "focus": "referrals, consultation and treatment expectations",
    "proof": "provider credentials and clear care explanations",
    "intake": "appointment preference without diagnostic records"
  },
  "/fertility-clinic-web-design-colorado": {
    "name": "Fertility Clinics",
    "focus": "consultations, evaluation steps and care options",
    "proof": "provider credentials and honest outcome explanations",
    "intake": "private callback preference without sensitive history"
  },
  "/hormone-therapy-web-design-colorado": {
    "name": "Hormone Therapy",
    "focus": "consultation, assessment and follow-up",
    "proof": "provider credentials and cautious suitability explanations",
    "intake": "appointment preference without lab reports"
  },
  "/iv-therapy-web-design-colorado": {
    "name": "IV Therapy",
    "focus": "consultation, service limits and appointment options",
    "proof": "provider credentials and clear safety boundaries",
    "intake": "booking preference without health details"
  },
  "/massage-therapy-web-design-colorado": {
    "name": "Massage Therapy",
    "focus": "session types, duration and booking policies",
    "proof": "therapist credentials and actual studio photos",
    "intake": "session preference and availability"
  },
  "/mental-health-web-design-colorado": {
    "name": "Mental Health Practices",
    "focus": "therapy formats, provider fit and first sessions",
    "proof": "provider credentials and clear privacy expectations",
    "intake": "safe contact preference without private clinical details"
  },
  "/ob-gyn-web-design-colorado": {
    "name": "OB-GYN Practices",
    "focus": "visit types, referral questions and appointment access",
    "proof": "provider credentials and clear patient information",
    "intake": "appointment preference without sensitive history"
  },
  "/optometry-web-design-colorado": {
    "name": "Optometry",
    "focus": "eye exams, eyewear and appointment options",
    "proof": "provider credentials and accurate office services",
    "intake": "appointment preference and eyewear questions"
  },
  "/oral-surgeon-web-design-colorado": {
    "name": "Oral Surgeons",
    "focus": "consultations, referrals and procedure preparation",
    "proof": "provider credentials and patient-friendly process",
    "intake": "callback preference without clinical attachments"
  },
  "/pediatric-dentist-web-design-colorado": {
    "name": "Pediatric Dentists",
    "focus": "first visits, child-friendly care and appointment access",
    "proof": "provider credentials and real office photos",
    "intake": "parent callback details without child health records"
  },
  "/pediatrician-web-design-colorado": {
    "name": "Pediatricians",
    "focus": "new patient access, visits and office policies",
    "proof": "provider credentials and current appointment information",
    "intake": "parent callback preference without child health details"
  },
  "/periodontist-web-design-colorado": {
    "name": "Periodontists",
    "focus": "consultation access and offered gum care services",
    "proof": "provider credentials and clear care explanations",
    "intake": "appointment preference without clinical records"
  },
  "/podiatry-web-design-colorado": {
    "name": "Podiatry",
    "focus": "consultation types, referrals and office access",
    "proof": "provider credentials and current service details",
    "intake": "callback preference without diagnostic details"
  },
  "/primary-care-web-design-colorado": {
    "name": "Primary Care",
    "focus": "new patient appointments, hours and insurance questions",
    "proof": "provider credentials and accurate office information",
    "intake": "appointment preference without health history"
  },
  "/urgent-care-web-design-colorado": {
    "name": "Urgent Care",
    "focus": "hours, walk-in policies and services",
    "proof": "accurate current access details and provider information",
    "intake": "general access questions without clinical details"
  },
  "/weight-loss-clinic-web-design-colorado": {
    "name": "Weight Loss Clinics",
    "focus": "consultation steps, program scope and follow-up",
    "proof": "provider credentials and honest expectations",
    "intake": "consultation preference without measurements or health history"
  },
  "/bankruptcy-lawyer-web-design-colorado": {
    "name": "Bankruptcy Lawyers",
    "focus": "consultation steps and debt-relief options",
    "proof": "attorney credentials and clear legal scope",
    "intake": "callback preference without financial account details"
  },
  "/business-lawyer-web-design-colorado": {
    "name": "Business Lawyers",
    "focus": "contracts, company structure and business disputes",
    "proof": "attorney credentials and practice-area experience",
    "intake": "consultation topic without confidential documents"
  },
  "/dui-lawyer-web-design-colorado": {
    "name": "DUI Lawyers",
    "focus": "consultation access and representation process",
    "proof": "attorney credentials and no promised case outcomes",
    "intake": "safe callback preference and consultation timing"
  },
  "/employment-lawyer-web-design-colorado": {
    "name": "Employment Lawyers",
    "focus": "workplace disputes and consultation scope",
    "proof": "attorney credentials and representation boundaries",
    "intake": "callback details without confidential employment records"
  },
  "/financial-advisor-web-design-colorado": {
    "name": "Financial Advisors",
    "focus": "planning approach, services and fee structures",
    "proof": "qualifications and accurately described fiduciary status",
    "intake": "planning goals without account balances or logins"
  },
  "/immigration-lawyer-web-design-colorado": {
    "name": "Immigration Lawyers",
    "focus": "consultations, application types and process",
    "proof": "attorney credentials and clear service boundaries",
    "intake": "safe callback details without identity documents"
  },
  "/ip-lawyer-web-design-colorado": {
    "name": "Intellectual Property Lawyers",
    "focus": "trademarks, patents and protection strategy",
    "proof": "attorney qualifications and practice focus",
    "intake": "consultation goal without unreleased invention details"
  },
  "/real-estate-lawyer-web-design-colorado": {
    "name": "Real Estate Lawyers",
    "focus": "transactions, leases and property disputes",
    "proof": "attorney credentials and clear service scope",
    "intake": "consultation type without confidential contracts"
  },
  "/tax-attorney-web-design-colorado": {
    "name": "Tax Attorneys",
    "focus": "tax disputes, representation and consultations",
    "proof": "attorney credentials and clear fee process",
    "intake": "safe callback preference without tax returns"
  },
  "/workers-comp-lawyer-web-design-colorado": {
    "name": "Workers’ Compensation Lawyers",
    "focus": "consultation steps and workplace claims",
    "proof": "attorney credentials and honest representation scope",
    "intake": "callback preference without injury records"
  },
  "/barbershop-web-design-colorado": {
    "name": "Barbershops",
    "focus": "cuts, grooming services and booking options",
    "proof": "real work photos and current staff information",
    "intake": "service and preferred appointment time"
  },
  "/catering-web-design-colorado": {
    "name": "Catering Companies",
    "focus": "menus, event sizes and dietary accommodations",
    "proof": "real event photos and clear package inclusions",
    "intake": "event date, headcount and venue"
  },
  "/daycare-web-design-colorado": {
    "name": "Daycare Centers",
    "focus": "age groups, availability and enrollment steps",
    "proof": "accurate licensing and real facility information",
    "intake": "parent contact and tour preference without child records"
  },
  "/event-venue-web-design-colorado": {
    "name": "Event Venues",
    "focus": "capacity, packages and date availability",
    "proof": "real venue galleries and accessibility details",
    "intake": "event type, headcount and date"
  },
  "/personal-trainer-web-design-colorado": {
    "name": "Personal Trainers",
    "focus": "training goals, formats and introductory sessions",
    "proof": "qualifications and consented client examples",
    "intake": "session preference and general goals"
  },
  "/pet-grooming-web-design-colorado": {
    "name": "Pet Grooming",
    "focus": "grooming services, breed needs and booking policies",
    "proof": "real grooming photos and handling practices",
    "intake": "pet size, service and booking preference"
  },
  "/tattoo-shop-web-design-colorado": {
    "name": "Tattoo Shops",
    "focus": "styles, artist portfolios and consultation steps",
    "proof": "real healed work and accurately described safety practices",
    "intake": "design concept and consultation date"
  },
  "/veterinary-web-design-colorado": {
    "name": "Veterinary Practices",
    "focus": "services, appointment access and emergency boundaries",
    "proof": "provider qualifications and accurate office information",
    "intake": "appointment preference and general pet details"
  },
  "/videographer-web-design-colorado": {
    "name": "Videographers",
    "focus": "production formats, editing scope and deliverables",
    "proof": "real showreels and usage terms",
    "intake": "project scope, date and distribution plans"
  },
  "/wedding-photographer-web-design-colorado": {
    "name": "Wedding Photographers",
    "focus": "coverage, editing and gallery delivery",
    "proof": "real full wedding galleries and contract terms",
    "intake": "wedding date, venue and coverage hours"
  },
  "/yoga-studio-web-design-colorado": {
    "name": "Yoga Studios",
    "focus": "class types, schedules and first-visit options",
    "proof": "real studio photos and instructor qualifications",
    "intake": "class interest and booking preference"
  }
};

export function getIndustryAdvice(slug: string): IndustryAdvice | undefined {
  return INDUSTRY_ADVICE[`/${slug}`];
}
